










import Vue from 'vue';
import FaIcon from '@/components/FaIcon.vue';

export default Vue.extend({
  components: {
    FaIcon,
  },
  props: {
    hasPageBreak: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onClick() {
      this.$emit('click');
    },
  },
});
